import React from 'react';
import { Paper } from 'library';

import FormstackForm from '../../forms/FormstackForm/FormstackForm';

import './BlogSubscription.scss';

const BlogSubscription = () => {
  return (
    <Paper pad={{ top: 3, bottom: 3, left: 2, right: 2 }}>
      <h4 className="BlogSubscriptionHeader">
        All the insights you need to make homeownership less stressful and more accessible.
      </h4>
      <p className="BlogSubscriptionSubtitle">Never miss an update! Get the What's on Tap monthly newsletter.</p>
      <FormstackForm
        formKey="newlsetter_subscribe"
        title="Newsletter Subscribe Form"
        height="50"
        style={{ maxWidth: 475 }}
      />
    </Paper>
  );
};

export default BlogSubscription;
